"use strict";

var _interopRequireDefault = require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.regexp.replace");
var _objectSpread2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _cargoTrack = require("@/api/query/cargoTrack");
var _containerHistory = require("@/api/query/containerHistory");
var _date = require("@/utils/date");
var _util = require("@/utils/util");
var _vuex = require("vuex");
var _validate = require("@/utils/validate");
var _booking = require("@/api/bookSpace/booking");
var _utils = require("@/utils");
var _auth = require("@/utils/auth");
var _voyagePlanSearch = require("@/api/vessel/voyagePlanSearch");
var _elementUi = require("element-ui");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'cargoTracking',
  data: function data() {
    return {
      dialogTableVisible: false,
      selectValue: 0,
      selectOptions: [{
        label: this.$t('cargoTracking.blNo'),
        value: 0
      }, {
        label: this.$t('cargoTracking.containerNo'),
        value: 1
      }],
      form: {
        blNo: '',
        containerNo: ''
      },
      movement: undefined,
      baseInfo: undefined,
      sailingInfo: undefined,
      containerInfo: undefined,
      singleInfo: undefined,
      postInfo: undefined,
      isResult: false,
      isResultSingle: false,
      loading: null,
      rules: {
        blNo: [{
          required: true,
          message: this.$t('validate.blNo'),
          trigger: 'blur'
        }],
        containerNo: [{
          required: true,
          message: this.$t('validate.containerNo'),
          trigger: 'blur'
        }]
      }
    };
  },
  computed: (0, _objectSpread2.default)({}, (0, _vuex.mapGetters)(['permissions', 'userInfo'])),
  methods: {
    dateFormat: _date.dateFormat,
    toScale: _util.toScale,
    validateNull: _validate.validateNull,
    toSubscribe: function toSubscribe() {
      var _this = this;
      var hasToken = (0, _auth.getToken)();
      if (hasToken) {
        this.$refs.form.validate(function (valid) {
          if (valid) {
            _this.loading = (0, _utils.load)();
            (0, _cargoTrack.cargoTrackList)({
              blNo: _this.form.blNo
            }).then(function (response) {
              if (!_this.validateNull(response.data.list1) && !_this.validateNull(response.data.list2)) {
                _this.baseInfo = response.data.list1;
                if (!(0, _validate.validateNull)(response.data.list1)) {
                  (0, _voyagePlanSearch.subscribeCargo)({
                    blNo: _this.form.blNo
                  }).then(function (response) {
                    if (response.success === true) {
                      _this.$alert(_this.$t('voyagePlanSearch.subscribeSuccess'), _this.$t('voyagePlanSearch.subscribeTips'), {
                        confirmButtonText: _this.$t('voyagePlanSearch.sure'),
                        callback: function callback(action) {}
                      });
                    } else {
                      _this.$alert(JSON.stringify(response.data), _this.$t('voyagePlanSearch.subscribeTips'), {
                        confirmButtonText: _this.$t('voyagePlanSearch.sure'),
                        callback: function callback(action) {}
                      });
                    }
                  });
                }
                _this.sailingInfo = response.data.list2;
                _this.containerInfo = response.data.list3;
                _this.validateNull(response.data.movementcode) ? _this.movement = 0 : _this.movement = response.data.movementcode[0].movementCode;
                _this.isResult = true;
              } else {
                _this.baseInfo = [];
                _this.sailingInfo = [];
                _this.containerInfo = [];
                _this.movement = [];
                _this.isResult = true;
              }
            }).catch(function () {
              _this.baseInfo = [];
              _this.sailingInfo = [];
              _this.containerInfo = [];
              _this.movement = [];
              _this.isResult = false;
            }).finally(function () {
              _this.loading.close();
            });
          }
        });
      } else {
        var message = this.$i18n.locale === 'zh' ? '请先登录,再进行操作' : 'Please login first and then operate';
        _elementUi.Message.warning(message);
      }
    },
    /**
     * 点击船名跳转船舶动态汇率查询界面
     * @param row
     */
    handleVesselName: function handleVesselName(row, column, event, cell) {
      var _this2 = this;
      (0, _booking.queryListMainVessel)({
        vesselName: row.vesselName
      }).then(function (response) {
        if (!(0, _validate.validateNull)(response.data.records)) {
          var routeUrl = _this2.$router.resolve({
            path: '/topMenu/vesselMovementSearch',
            query: {
              vesselCode: response.data.records[0].vesselCode,
              vesselName: response.data.records[0].vesselName
            }
          });
          window.open(routeUrl.href, '_blank');
        }
      });
    },
    /**
     * 获取当前提单号箱号，箱动态
     * @param row
     */
    handle: function handle(row, column, event, cell) {
      var _this3 = this;
      this.form.containerNo = row.containerNo;
      this.loading = (0, _utils.load)();
      (0, _cargoTrack.cargoDetail)(this.form).then(function (response) {
        if (!_this3.validateNull(response.data.list)) {
          _this3.postInfo = response.data.list.reverse();
          _this3.dialogTableVisible = true;
        }
      }).finally(function () {
        _this3.loading.close();
      });
    },
    /**
     * 改变查询方式
     */
    changeQuery: function changeQuery() {
      this.isResult = false;
      this.isResultSingle = false;
      this.form.blNo = '';
      this.form.containerNo = '';
    },
    /**
     * 查询
     */
    toSearch: function toSearch() {
      var _this4 = this;
      if (this.selectValue === 1) {
        this.$refs.form.validate(function (valid) {
          if (valid) {
            (0, _containerHistory.movementSearch)({
              containerNo: _this4.form.containerNo
            }).then(function (response) {
              if (!_this4.validateNull(response.data.list)) {
                _this4.singleInfo = response.data.list;
                _this4.isResultSingle = true;
              } else {
                _this4.singleInfo = [];
                _this4.isResultSingle = true;
              }
            }).catch(function () {
              _this4.singleInfo = [];
              _this4.isResultSingle = false;
            });
          }
        });
      } else {
        this.$refs.form.validate(function (valid) {
          if (valid) {
            _this4.loading = (0, _utils.load)();
            (0, _cargoTrack.cargoTrackList)({
              blNo: _this4.form.blNo
            }).then(function (response) {
              if (!_this4.validateNull(response.data.list1) && !_this4.validateNull(response.data.list2)) {
                _this4.baseInfo = response.data.list1;
                _this4.sailingInfo = response.data.list2;
                _this4.containerInfo = response.data.list3;
                _this4.validateNull(response.data.movementcode) ? _this4.movement = 0 : _this4.movement = response.data.movementcode[0].movementCode;
                _this4.isResult = true;
              } else {
                _this4.baseInfo = [];
                _this4.sailingInfo = [];
                _this4.containerInfo = [];
                _this4.movement = [];
                _this4.isResult = true;
              }
            }).catch(function () {
              _this4.baseInfo = [];
              _this4.sailingInfo = [];
              _this4.containerInfo = [];
              _this4.movement = [];
              _this4.isResult = false;
            }).finally(function () {
              _this4.loading.close();
            });
          }
        });
      }
    },
    /**
     * 字符串首字母大写，其他小写
     */
    format: function format(str) {
      if (str == null) {
        return null;
      } else {
        var str1 = str.toLowerCase();
        var reg = /\b(\w)+\b/g;
        var newStr = str1.replace(reg, function (word) {
          return word.replace(word.charAt(0), word.charAt(0).toUpperCase());
        });
        return newStr;
      }
    },
    formatDate: function formatDate(row, column, cellValue, index) {
      row.etd = (0, _date.dateFormat)('YYYY-MM-DD', row.etd);
      return row.etd;
    },
    formatDate1: function formatDate1(row, column, cellValue, index) {
      row.eta = (0, _date.dateFormat)('YYYY-MM-DD', row.eta);
      return row.eta;
    },
    formatDate2: function formatDate2(row, column, cellValue, index) {
      row.eventDate = (0, _date.dateFormat)('YYYY-MM-DD', row.eventDate);
      return row.eventDate;
    },
    beforeInit: function beforeInit() {
      if (!this.validateNull(this.$route.params)) {
        if (!this.validateNull(this.$route.params.containerNo) && this.validateNull(this.$route.params.blNo)) {
          this.selectValue = 1;
        }
      }
      if (!this.validateNull(this.$route.query)) {
        if (!this.validateNull(this.$route.query.containerNo) && this.validateNull(this.$route.query.blNo)) {
          this.selectValue = 1;
        }
      }
    },
    init: function init() {
      if (!this.validateNull(this.$route.params)) {
        this.form.blNo = this.$route.params.blNo;
        this.form.containerNo = this.$route.params.containerNo;
        this.toSearch();
      }
      if (!this.validateNull(this.$route.query)) {
        this.form.blNo = this.$route.query.blNo;
        this.form.containerNo = this.$route.query.containerNo;
        this.toSearch();
      }
    }
  },
  created: function created() {
    this.beforeInit();
  },
  mounted: function mounted() {
    this.init();
  }
};